export function createMarketingApi(baseUrl) {
  return {
    marketing: {
      sendUtmData: `${baseUrl}/v1/marketing/data/`,
    },
  };
}
